
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice"; 
import userReducer from "../slices/userSlice";
import customerReducer from "../slices/customerSlice";
import templateReducer from "../slices/templateSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer, 
    user: userReducer, // Manages Create/ModifyUser state
    customer: customerReducer,
    template: templateReducer,
  },
});